// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal .modal {
    border: thin solid var(--danger-color-light);
    color: var(--danger-color-dark);
    z-index: 2000;
}
.error-modal .modal .modal__close svg {
    color: var(--danger-color-main);
}
.error-modal__wrapper {
    padding: 10px;
}
.error-modal .error-modal__wrapper a:link,
.error-modal .error-modal__wrapper a:visited,
.error-modal .error-modal__wrapper a:active {
    color: var(--danger-color-main);
}
.error-modal .error-modal__wrapper a:hover {
    color: var(--danger-color-main-highlight);
}
.error-modal .error-modal__button {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/components/errors/ErrorModal.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,+BAA+B;IAC/B,aAAa;AACjB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,aAAa;AACjB;AACA;;;IAGI,+BAA+B;AACnC;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".error-modal .modal {\n    border: thin solid var(--danger-color-light);\n    color: var(--danger-color-dark);\n    z-index: 2000;\n}\n.error-modal .modal .modal__close svg {\n    color: var(--danger-color-main);\n}\n.error-modal__wrapper {\n    padding: 10px;\n}\n.error-modal .error-modal__wrapper a:link,\n.error-modal .error-modal__wrapper a:visited,\n.error-modal .error-modal__wrapper a:active {\n    color: var(--danger-color-main);\n}\n.error-modal .error-modal__wrapper a:hover {\n    color: var(--danger-color-main-highlight);\n}\n.error-modal .error-modal__button {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
